const crosselingPdp = document.querySelector('.container-complementary-products-custom');
const crossellingAppPdp = document.querySelector('.gfbBundleUpsellWrapper');
const pairsWell = document.querySelector('.related_products_custom .inline-richtext')?.textContent.trim();
const bundleUp = document.querySelectorAll('.related_products_custom .inline-richtext')[1]?.textContent.trim();
const crosselingCart = document.querySelector('.cart-drawer');
const pairsWellContainer = document.querySelector('.related_products_custom');
const bundleUpContainer = document.querySelectorAll('.related_products_custom')[1];


/* Listoooooooooo */
if(crosselingPdp != null){
    crosselingPdp.addEventListener('click', (event) => {
      const target = event.target;
      let interactionType = '';

      if (target.closest('.color-swatch')) {
        interactionType = 'color_select';
      } else if (target.closest('.card--media')) {
        interactionType = 'product_click';
      } else if (target.closest('.buy-button-extra') && !target.closest('.gfbFooterAddToCartBtn_Template1')) {
        interactionType = 'add_to_cart';
      } else {
        return;
      }

      const productName = document.querySelector('.product__title h1')?.textContent.trim() || '';
      const recommendedProduct = document.querySelector('.span-tittle-extra p')?.textContent.trim() || '';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "cross_selling_lateral",
        main_product: productName,
        recommended_product: recommendedProduct,
        interaction_type: interactionType
      });
    });
}

if(crosselingCart != null){
    const upsellcontainers = document.querySelectorAll('.cart-drawer .card-wrapper');
    upsellcontainers.forEach(container => {
        container.addEventListener('click', (e) => {

            const target = e.target;
            const drawer = document.querySelector('.drawer');
            const productName = drawer?.querySelector('#CartDrawer-Item-1 .cart-item__name')?.textContent.trim() || 'Empty cart';
            const recommendedProduct = container.querySelector('.span-tittle-cart')?.textContent.trim() || '';

            let interactionType = '';

              if (target.closest('.color-swatch')) {
                interactionType = 'color_select';
              } else if (target.tagName === 'buy-button-extra' || target.closest('.buy-button-extra span')) {
                interactionType = 'add_to_cart';
              } else {
                return;
              }

              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: "cross_selling_cart_lateral",
                main_product: productName,
                recommended_product: recommendedProduct,
                interaction_type: interactionType
              });
        });
    });
}



if (pairsWellContainer != null) {
    pairsWellContainer.addEventListener('click', (event) => {
      const target = event.target;
      let interactionType = '';

          if (target.closest('.color-swatch')) {
            interactionType = 'color_select';
          } else if (target.closest('.quick-add ') && !(target.closest('.product-form__input '))) {
            interactionType = 'add_to_cart';
          } else if (target.closest('.product-form__input .swatch')) {
            interactionType = 'size_select';
          } else if (target.closest('.card__inner') && !(target.closest('.product-form__input ') || target.closest('.full-unstyled-link') && !target.closest('.quick-add')) && !(target.closest('.product-form__input '))) {
            interactionType = 'product_click';
          } else {
            return;
          }

        const productName = document.querySelector('.product__title h1')?.textContent.trim() || '';
        const container = event.target.closest('li') || event.target.closest('div');
        const recommendedProduct = container?.querySelector('.full-unstyled-link').textContent.trim() || '';

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: "cross_selling_pairs",
            main_product: productName,
            recommended_product: recommendedProduct,
            interaction_type: interactionType
        });
    });
}

if(bundleUpContainer != null){
    bundleUpContainer.addEventListener('click', (event) => {
      const target = event.target;
      let interactionType = '';

    if (target.closest('.full-unstyled-link')) {
        interactionType = 'product_click';
      } else if(target.closest('.card__inner')){
        interactionType = 'slider_click';
    }else{
        return;
      }

            const productName = document.querySelector('.product__title h1')?.textContent.trim() || '';
            const container = event.target.closest('li') || event.target.closest('div');
            const recommendedProduct = container?.querySelector('.full-unstyled-link').textContent.trim() || '';

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: "upselling_bundle",
                main_product: productName,
                recommended_product: recommendedProduct,
                interaction_type: interactionType
            });
    });
}


function attachListener() {
  const crossellingAppPdp = document.querySelector('.gfbBundleUpsellWrapper');
  let contar = true;

  if (crossellingAppPdp) {
    crossellingAppPdp.addEventListener('click', (event) => {
      const target = event.target;
      let interactionType = '';
      const dropdownWrapper = target.closest('.gfbMasterDropdownAndQuantitySelectorWrapper');

      if (dropdownWrapper) {
        if (!contar) {
          contar = !contar;
          return;
        }
        interactionType = 'color_select';
        contar = !contar;
      } else if (target.closest('.gfbProductTitle_Template1')) {
        interactionType = 'product_click';
      } else if (target.closest('.gfbFooterAddToCartBtn_Template1')) {
        interactionType = 'add_to_cart';
      } else {
        return;
      }

      const productName = document.querySelector('.product__title h1')?.textContent.trim() || '';
      const recommendedProductEl = document.querySelectorAll('.gfbProductTitle_Template1')[1];
      const recommendedProduct = recommendedProductEl?.textContent.trim() || '';
      if (recommendedProductEl) {
        recommendedProductEl.setAttribute('title', recommendedProduct);
      }
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "cross_selling_app",
        main_product: productName,
        recommended_product: recommendedProduct,
        interaction_type: interactionType
      });
    }, true);
    return true;
  }
  return false;
}

if (!attachListener()) {
  const observer = new MutationObserver(() => {
    if (attachListener()) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
